import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const RowNumFormatter = ({ value }) => {
  return (
    <span style={{ fontSize: 12, fontWeight: 600, color: '#333', display: 'inline-block', width: 22, textAlign: 'right' }}>{value}</span>
  );
};
const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

export default RowNumTypeProvider;
